import React, { useState } from "react";
import LeaderboardRow from "./LeaderboardRow";

const LeaderboardTable = ({ query, customers }) => {
  const [sort, setSort] = useState("reservations");

  const renderCustomers = () => {
    if (Array.isArray(customers)) {
      let customersRender = [...customers];
      customersRender = customersRender.sort((a, b) =>
        parseInt(a[sort]) > parseInt(b[sort]) ? -1 : 1
      );
      if (query && query !== "") {
        customersRender = customersRender.filter(
          ({ name, last_name, email }) =>
            String(name).includes(query) ||
            String(last_name).includes(query) ||
            String(email).includes(query)
        );
      }
      return customersRender.map((customer) => (
        <LeaderboardRow key={customer.customer_id} customer={customer} />
      ));
    }
  };

  return (
    <div className="table-responsive">
      <table className="leaderboard table">
        <thead>
          <tr className="bg-light bold p-2">
            <th>Nombre</th>
            <th>Instagram</th>
            <th
              onClick={() => setSort("reservations")}
              className={sort === "reservations" ? "bg-primary text-white" : ""}
            >
              Reservadas{" "}
              <i
                className={`fa fa-chevron-${
                  sort === "reservations" ? "down" : "up"
                }`}
              ></i>
            </th>
            <th
              onClick={() => setSort("attended")}
              className={sort === "attended" ? "bg-primary text-white" : ""}
            >
              Asistencias
              <i
                className={`fa fa-chevron-${
                  sort === "attended" ? "down" : "up"
                }`}
              ></i>
            </th>
            <th
              onClick={() => setSort("streaks")}
              className={sort === "streaks" ? "bg-primary text-white" : ""}
            >
              Streaks
              <i
                className={`fa fa-chevron-${
                  sort === "streaks" ? "down" : "up"
                }`}
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>{renderCustomers()}</tbody>
      </table>
    </div>
  );
};

export default LeaderboardTable;
